import { IEntity } from "../ecs/entity";

export const clearScreen = (ctx: CanvasRenderingContext2D) => (
  es: IEntity[]
) => {
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
};
